// extracted by mini-css-extract-plugin
module.exports = {"embeds":"SocialEmbed-module__embeds___12FcV"};